import { render, staticRenderFns } from "./commissioniProdotti.vue?vue&type=template&id=8e877fd2&"
import script from "./commissioniProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioniProdotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports